module.exports=require('./lib/vue2-countdown.vue')



//////////////////
// WEBPACK FOOTER
// ./~/_vue2-countdown@1.0.8@vue2-countdown/index.js
// module id = 472
// module chunks = 41